import { FC } from "react";

interface ConsidferacoesAlteracoesObrigacoesProps {}

const ConsidferacoesAlteracoesObrigacoes: FC<ConsidferacoesAlteracoesObrigacoesProps> = () => {
    return <>
        <div className="title">Considerações Gerais</div>

        <div className="sub-title-minor">Obrigações da Revenda</div>

        <div className="default-text-list"><span>É de responsabilidade da revenda diretamente com o cliente:</span></div>

        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Negociação;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Cobrança e recebimento dos valores dos serviços;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Agendamento de entrega e dos serviços;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Recebimento e conferência dos materiais durante a entrega;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Instalação e desinstalação do sistema;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Assistência técnica para produtos e serviços;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Serviços de manutenção;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Suporte técnico;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Atendimento de garantias;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Apresentações de ART;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Apresentação/acompanhamento* das autorizações junto à Concessionária local.</div>
            </div>
        </div>

        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Garantir que no local de instalação do microinversor/inversor exista um bom nível de sinal Wi-Fi para que o sistema de monitoramento opere de forma correta.</div>
            </div>
        </div>

        <br />

        <div className="default-text-list"><span>*O acompanhamento da Revenda é exclusivo para o pedido de homologação junto à Concessionária. O prazo de resposta e aprovação dependem apenas da análise da rede elétrica local. A Intelbras e a Revenda estão isentas de qualquer responsabilidade neste processo, conforme determina a legislação vigente.</span></div>
    </>
}

export default ConsidferacoesAlteracoesObrigacoes;